import AxiosInstance from 'config/apiServiceApiGateway'

import {
  AssetSupplyOrderParamsInterface,
  AssetInventoryListParamsInterface,
  AssetInventoryListV2ParamsInterface,
  AssetSupplyOrderListResponseInterface,
  AssetSupplyOrderCreateParamsInterface,
  AssetSupplyOrderCreateResponseInterface,
  AssetSupplyOrderDetailResponseInterface,
  AssetSupplyOrderUpdateParamsInterface,
  AssetSupplyOrderUpdateResponseInterface,
  AssetSupplyOrderMoveableAssetResponseInterface,
  AssetSupplyOrderInventoryCodeResponseInterface,
  AssetSupplyOrderUpdateDataParamsInterface,
  AssetSupplyOrderUpdateItemQuantityInterface,
  AssetSupplyOrderUpdateItemQuantityResponseInterface,
  AssetSupplyOrderAssetInventoryDetailInterface,
} from 'features/AssetManagement/@types/typeSupplyOrder'

export const getSupplyOrderListAPI = (query: AssetSupplyOrderParamsInterface) =>
  AxiosInstance.Get<AssetSupplyOrderListResponseInterface, true>({
    url: '/ams/internal/v1/so/list',
    params: query,
  })

const getWithOptionalRepeatedCategoryIds = <TResponse>(
  url: string,
  baseParams: Record<string, unknown>,
  asset_category_ids?: Array<string | number>,
) => {
  if (asset_category_ids && asset_category_ids.length > 0) {
    const searchParams = new URLSearchParams()

    Object.entries(baseParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) searchParams.append(key, String(value))
    })

    asset_category_ids.forEach((id) => searchParams.append('asset_category_ids', String(id)))

    return AxiosInstance.Get<TResponse, true>({ url: `${url}?${searchParams.toString()}` })
  }

  return AxiosInstance.Get<TResponse, true>({ url, params: baseParams })
}

export const getAssetInventoryListAPI = (params: AssetInventoryListParamsInterface) => {
  const { origin_id, search_params, page_index, page_size, asset_category_ids, status } = params

  const baseParams: Record<string, unknown> = {
    page_index: page_index || 0,
    page_size: page_size || 20,
    ...(origin_id !== undefined && { origin_id }),
    ...(search_params && { search_params }),
    ...(status && { status }),
  }

  return getWithOptionalRepeatedCategoryIds<AssetSupplyOrderMoveableAssetResponseInterface>(
    '/ams/internal/v1/assets_inventory/list',
    baseParams,
    asset_category_ids,
  )
}

export const getAssetInventoryListV2 = (params: AssetInventoryListV2ParamsInterface) => {
  const { origin_id, search_params, page_index, page_size, asset_category_ids, status, codes } =
    params

  const baseParams: Record<string, unknown> = {
    page_index: page_index || 0,
    page_size: page_size || 20,
    ...(origin_id !== undefined && { origin_id }),
    ...(codes !== undefined && { codes }),
    ...(search_params && { search_params }),
    ...(status && { status }),
  }

  return getWithOptionalRepeatedCategoryIds<AssetSupplyOrderMoveableAssetResponseInterface>(
    '/ams/internal/v1/asset-inventories',
    baseParams,
    asset_category_ids,
  )
}

export const postSupplyOrderCreateAPI = (payload: AssetSupplyOrderCreateParamsInterface) =>
  AxiosInstance.Post<AssetSupplyOrderCreateResponseInterface, true>({
    url: '/ams/internal/v1/so/create',
    data: payload,
  })

export const postSupplyOrderUpdateAPI = (payload: AssetSupplyOrderUpdateParamsInterface) =>
  AxiosInstance.Post<AssetSupplyOrderUpdateResponseInterface, true>({
    url: '/ams/internal/v1/so/update_progress',
    data: payload,
  })

export const getSupplyOrderDetailAPI = (so_id: string, asset_inventory_status?: string) =>
  AxiosInstance.Get<AssetSupplyOrderDetailResponseInterface, true>({
    url: `/ams/internal/v1/so/detail`,
    params: { so_id, asset_inventory_status },
  })

// ini untuk check barcode scan di asset page.
export const getSupplyOrderInventoryByCodeAPI = (code: string) =>
  AxiosInstance.Get<AssetSupplyOrderInventoryCodeResponseInterface, true>({
    url: `/ams/internal/v1/assets_master/detail`,
    params: { code },
  })

// ini untuk check barcode scan di wms page check quantity.
export const getSupplyOrderAssetInventoryDetailAPI = (
  code: string,
  type?: string,
  origin?: string,
) =>
  AxiosInstance.Get<AssetSupplyOrderAssetInventoryDetailInterface, true>({
    url: '/ams/internal/v1/assets_inventory/detail',
    params: { code, origin, type },
  })

export const postSupplyOrderUpdateDataAPI = (payload: AssetSupplyOrderUpdateDataParamsInterface) =>
  AxiosInstance.Post<AssetSupplyOrderUpdateResponseInterface, true>({
    url: '/ams/internal/v1/so/update',
    data: payload,
  })

export const postSupplyOrderUpdateItemQuantityAPI = (
  payload: AssetSupplyOrderUpdateItemQuantityInterface,
) =>
  AxiosInstance.Post<AssetSupplyOrderUpdateItemQuantityResponseInterface, true>({
    url: '/ams/internal/v1/so/update_item_quantity',
    data: payload,
  })
